var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 690.68 658.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0e538c;}.cls-2{fill:#4d87b9;isolation:isolate;opacity:.8;}.cls-3{opacity:.5;}.cls-4{fill:#b2b2b2;}.cls-5{fill:#d3d3d3;}.cls-6{fill:none;stroke:#0e538c;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6px;}.cls-7{fill:#ededed;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.95,27.44c-19.38,8.72-66.44,33-124.2,112.65C33.28,197.27,12.55,225.86,3.98,268.62c-16.47,82.25,21.17,150.79,56.89,215.81,31.22,56.84,59.09,107.58,114.97,127.91,36.39,13.24,42.75-1.66,108.31,10.11,80.12,14.38,86.5,39.48,136.46,35.61,40.42-3.13,71.76-22.32,107.61-44.27,33.52-20.52,51.52-31.54,66.43-53.44,27.41-40.24,13.08-71.25,26-131.42,14.62-68.12,41.42-67.71,59.21-125.64,27.98-91.14,.56-218.88-69.32-255.62-42.37-22.27-61.05,9.56-144.69-15.86C416.54,16.81,403.78-.11,360.7,0c-15.81,.04-19.58,2.34-86.65,14.44-70.47,12.72-65.61,8.73-75.1,13Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 352.77,
    cy: 326.43,
    rx: 225.66,
    ry: 243.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 341.72,
    cy: 326.43,
    rx: 225.66,
    ry: 243.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M536.74,331.61c0,115.14-87.86,208.45-196.42,208.45-40.71,0-78.76-13.15-110.38-35.67-52.6-37.49-87.3-100.87-87.3-172.78,0-115.14,89.26-208.45,197.82-208.45,33.72,0,65.33,8.95,93.03,24.9,61.42,35.12,103.25,104.09,103.25,183.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M159.29,342.8c0,71.91,34.84,135.28,87.3,172.78-61.7-35.26-103.81-104.23-103.81-183.27,0-115.14,89.4-208.45,197.82-208.45,40.57,0,78.2,13.01,109.54,35.39-27.7-15.81-59.32-24.9-93.03-24.9-108.42,0-197.82,93.31-197.82,208.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 321.85,
    cy: 335.81,
    r: 13.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 321.85,
    y1: 335.81,
    x2: 471.55,
    y2: 268.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 323.39,
    y1: 337.49,
    x2: 248.82,
    y2: 292.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 327.45,
    cy: 341.54,
    r: 13.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 327.45,
    y1: 341.54,
    x2: 477.14,
    y2: 274.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 328.99,
    y1: 343.22,
    x2: 254.56,
    y2: 298.03
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.60ca3c127036af08c133aeced25ebdaf.svg";
export { ForwardRef as ReactComponent };